export default __webpack_public_path__ + "static/media/partner-partizan.867aee1c.webp";